
import React from 'react';
import { useNavigate } from 'react-router-dom';
// import { AppUserContext } from '../../App';
import Nav from '../../components/breadcrumb';
import PaymentForm from './staff-payment-form';
// import { ErrorLoading } from '../../components/loading';

const payment = {
    payroll_type: "",
    overtime_rate: 0,
    workers: []
}

const NewPayment = () => {

    const nav_items = [
        { title: 'Staff Payments', href: '/app/staff-payments' },
        { title: 'Initiate Payment' }
    ];

    const navigate = useNavigate();

    const handleSubmit = (details) => {
        navigate(`/app/staff-payments/${details.id}`);
    }

    // const { profile } = useContext(AppUserContext);

    // if (profile.roles.indexOf('finance') === -1) {
    //     return <ErrorLoading>You do not have permission to create an expense.</ErrorLoading>;
    // }



    return (
        <>
            <Nav items={nav_items} />

            <PaymentForm
                details={payment}
                action="create"
                onSubmit={handleSubmit}
            />
        </>
    )
}

/**
 * 
 * @param {Object} props
 * @param {import("../../resources/api/payroll").StaffPaymentObject} props.details 
 * @param {React.Dispatch<React.SetStateAction<import("../../resources/api/payroll").StaffPaymentObject>>} props.setDetails 
 */
const EditPayment = ({ details, setDetails }) => {

    const nav_items = [
        { title: 'Staff Payments', href: '/app/staff-payments' },
        { title: details.reference, href: `/app/staff-payments/${details.id}` },
        { title: 'Edit Payment Details' }
    ];

    const navigate = useNavigate();

    const handleSubmit = (details) => {
        setDetails(d => ({ ...d, ...details }));
        navigate(`/app/staff-payments/${details.id}`);
    }


    return (
        <>
            <Nav items={nav_items} />

            <div className="max-800 p-2">
                <PaymentForm
                    details={details}
                    onSubmit={handleSubmit}
                    action="edit"
                />
            </div>
        </>
    )

}


export { EditPayment }

export default NewPayment;

